const ajax = require('ajax')
const numbers = require('numbers')
const trans = require('trans')

const gameLimitsTpl = require('../../Block/game_limits.html.twig')
const elementFromHtmlString = require('Helpers/elementFromHtmlString')

const RENDER_INTERVAL = 1000

/**
 * @param  {HTMLDivElement} container
 * @param  {string[]} limitsToShow
 * @param  {boolean} isLogged
 * @param  {boolean} forFun
 * @param  {number} syncInterval
 */
const GameLimitsView = (container, limitsToShow, isLogged, forFun, syncInterval) => {
  /**
   * @param  {HTMLDivElement} el
   */
  let el
  let renderTimeout
  let pollTimeout
  let lastPollTime
  let limits

  const defs = {
    playTimeOverAllLimit: {
      type: 'limit',
      enabled: isLogged,
    },
    playTimeLimit: {
      type: 'limit',
      enabled: !forFun,
    },
    loginTime: {
      type: 'limit',
      enabled: !forFun,
    },
    lossOverAllLimit: {
      type: 'limit',
      enabled: !forFun,
    },
    lossMonthLimit: {
      type: 'limit',
      enabled: !forFun,
    },
    hazardAddictionInfo: {
      type: 'text',
      text: trans('hazard_addiction_info'),
      enabled: false,
    },
  }

  const init = () => {
    if (!Array.isArray(limitsToShow)) {
      return
    }
    if (isLogged) {
      getData()
    }
    render()
  }

  const render = () => {
    if (!container) {
      return
    }
    const items = limitsToShow
      .map((limitId) => {
        const def = defs[limitId]
        if (def && def.enabled) {
          if (def.type === 'limit') {
            return getLimitText(limitId)
          } else if (def.type === 'text') {
            return def.text
          }
        }

        return null
      })
      .filter(Boolean)
    el = elementFromHtmlString(gameLimitsTpl({ items }))

    container.innerHTML = ''
    container.appendChild(el)

    clearTimeout(renderTimeout)
    renderTimeout = setTimeout(render, RENDER_INTERVAL)
  }

  const getLimitText = (limitId) => {
    const limit = limits && limits[limitId]
    if (limit) {
      if (limit.type === 'time') {
        if (limit.current) {
          return `${limit.name}: ${numbers
            .millisecondsToHMS(limit.current * 1000 + Date.now() - lastPollTime)
            .replace(/ /g, '&nbsp;')}`
        } else {
          return ''
        }
      } else if (limit.type === 'money') {
        return `${limit.name}: ${numbers.money(limit.current)}`
      } else {
        return `${limit.name}: ${limit.current}`
      }
    }

    return ''
  }

  const remove = () => {
    try {
      clearTimeout(renderTimeout)
      clearTimeout(pollTimeout)
      container.removeChild(el)
    } catch (e) {
      console.error(e)
    } finally {
      container = undefined
    }
  }

  const getData = () => {
    const queueNextPoll = () => {
      if (container) {
        clearTimeout(pollTimeout)
        pollTimeout = setTimeout(getData, syncInterval)
      }
    }
    ajax.getJson(
      '/content-loader/cs/profile/limits-status',
      (data) => {
        limits = data.data.limits
        lastPollTime = Date.now()
        queueNextPoll()
      },
      () => {
        limits = undefined
        queueNextPoll()
      },
    )
  }

  if (container) {
    init()
  }

  return { remove }
}

module.exports = GameLimitsView
